import { environment } from "@benefitsui/environments/environment";

export const formatActiveEnvironmentDocumentLink: (item: string) => string = function(item: string): string {
  const filePrefix = environment.documentDownloadLink;

  return `${filePrefix}${item}`;
}